export const WEBSITE = 'Website';
export const CALL = 'Call';
export const MAIL = 'Mail';
export const OWN_ANCHOR = 'OwnAnchor';
export const OTHER_CONTENT = 'OtherContent';
export const TRIGGER_EVENT = 'TriggerEvent';
export const CUSTOM_CTA = 'CustomCTA';
export const JOIN_SEGMENT = 'JoinSegment';
export const ACTIVATE_BROADCAST = 'ActivateBroadcast';



// WEBPACK FOOTER //
// ./src/constants/CTATypes.js